import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
  label?: string | null | undefined;
};
export const SpinnerLabel = ({ className, label }: Props) => (
  <div
    className={classnames(
      'mt-20 max-w-4/5 text-center font-brand text-20 leading-normal text-black sm:max-w-3/5',
      {
        'sr-only': !label,
      },
      className,
    )}
    aria-live="polite"
  >
    {label ? label : 'Loading'}
  </div>
);
